import { FC } from 'react';
import Image from 'next/image';
import { SizeType } from '@shared/types/size.type';
import { ProfileWrapper } from './CreatorProfile.style';
interface Props {
  imageUrl: string;
  name: string;
  size: SizeType;
}
const CreatorProfile: FC<Props> = ({
  imageUrl,
  name,
  size
}: Props) => {
  return <ProfileWrapper $size={size}>
            <Image className="image" src={imageUrl || '/images/default/creator-profile.png'} alt="profile image" onError={({
      currentTarget
    }) => {
      currentTarget.onerror = null; // prevents looping
      currentTarget.src = '/images/default/creator-profile.png';
    }} width={24} height={24} />
            <span className="name">{name}</span>
        </ProfileWrapper>;
};
export default CreatorProfile;